import React from "react";

import { List as AntList } from "antd";

import { trackMixpanel, useNavigate } from "utils";

import { Icon } from "components";

enum LIST_ICONS {
  WEBINAR = "webinar",
  WRITING = "writing",
  MAIL = "mail",
  HEART = "heart",
  HELP = "help",
}

type ListItemProps = {
  title: string;
  description?: string;
  link?: string;
  icon?: LIST_ICONS;
  onClick?: () => void;
  dataTestId?: string;
};

const getIcon = (icon: LIST_ICONS) => {
  if (icon === "webinar") {
    return <Icon className="icon" iconName="tabler/world-longitude" />;
  }
  if (icon === "writing") {
    return <Icon className="icon" iconName="tabler/writing" />;
  }
  if (icon === "mail") {
    return <Icon className="icon" iconName="tabler/mail" />;
  }
  if (icon === "heart") {
    return <Icon className="icon" iconName="klim/heart-handshake" />;
  }
  if (icon === "help") {
    return <Icon className="icon" iconName="tabler/help" />;
  }

  return <></>;
};

export const List = ({ items }: { items: ListItemProps[] }) => {
  const navigate = useNavigate();
  return (
    <AntList
      bordered
      dataSource={items}
      renderItem={(item, i) =>
        item.link ? (
          <AntList.Item
            className={`pointer ${i !== items.length - 1 ? "border" : ""}`}
            data-testid={item.dataTestId}
            onClick={() => {
              if (typeof item.link === "string") navigate(item.link);
              trackMixpanel("ClickLink", {
                linkText: item.title,
                link: item.link,
              });
            }}
          >
            <AntList.Item.Meta title={item.title} description={item.description && item.description !== "" ? item.description : null} />
            <Icon iconName="tabler/chevron-right" className="icon inline" />
          </AntList.Item>
        ) : (
          <AntList.Item className={`pointer ${i !== items.length - 1 ? "border" : ""}`} data-testid={item.dataTestId} onClick={() => item.onClick?.()}>
            {item.icon && getIcon(item.icon)}
            <AntList.Item.Meta title={item.title} description={item.description && item.description !== "" ? item.description : null} />
            <Icon iconName="tabler/chevron-right" className="icon inline" />
          </AntList.Item>
        )
      }
    />
  );
};
